import Id from './Id';
import Created from './Created';
import Updated from './Updated';
import CancelledRepresentativePlacement from './CancelledRepresentativePlacement';
import Currency from './Currency';
import Customer from './Customer';
import CustomerAddress from './CustomerAddress';
import GrossPrice from './GrossPrice';
import NetPrice from './NetPrice';
import ReceiptNumber from './ReceiptNumber';
import RepresentativeSale from './RepresentativeSale';
import Shop from './Shop';
import Status from './Status';
import Storage from './Storage';
import Supplier from './Supplier';
import Category from './Category';
import RepresentativeUser from './RepresentativeUser';


export const labels = {
  Id: 'Id',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  Category: 'Kategória',
  Currency: 'Deviza',
  CancelledRepresentativePlacement: 'Kapcsoldódó sztornózott kihelyezés',
  Customer: 'Vevő',
  CustomerAddress: 'Vevő címe',
  GrossPrice: 'Bruttó ár',
  NetPrice: 'Nettó ár',
  ReceiptNumber: 'Bizonylat szám',
  RepresentativeSale: 'Képviselői eladás',
  Shop: 'Üzlet',
  Status: 'Státusz',
  Storage: 'Raktár',
  Supplier: 'Szállító',
  RepresentativeUser: 'Képviselő',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'CancelledRepresentativePlacement',
}, {
  value: 'Category',
}, {
  value: 'Currency',
}, {
  value: 'Customer',
}, {
  value: 'CustomerAddress',
}, {
  value: 'GrossPrice',
}, {
  value: 'NetPrice',
}, {
  value: 'ReceiptNumber',
}, {
  value: 'RepresentativeSale',
}, {
  value: 'Shop',
}, {
  value: 'Status',
}, {
  value: 'Storage',
}, {
  value: 'Supplier',
}, {
  value: 'RepresentativeUser',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Category',
}, {
  value: 'RepresentativeUser',
}, {
  value: 'Customer',
}, {
  value: 'Shop',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'descending'
};

export default {
  Id,
  Created,
  Updated,
  CancelledRepresentativePlacement,
  Currency,
  Category,
  Customer,
  CustomerAddress,
  GrossPrice,
  NetPrice,
  ReceiptNumber,
  RepresentativeSale,
  Shop,
  Status,
  Storage,
  Supplier,
  RepresentativeUser,
};
